<div class="topbar-container">
    <div class="text" (click)="onBack()" class="back">Back</div>
    <div class="subtitle-smaller">{{ title }}</div>
    <ng-content></ng-content>
</div>
